import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class CommentId extends IdValueObject {
  static create(value: string): CommentId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new CommentId(value);
  }
}
